export default "__VITE_ASSET__COD$e6_i__"